<template>
  <div class="ledger_obj_summary" v-bind:title="title">
    <div v-on:click="toggle_details">
      {{obj_type}}: 

      <RippleStateObj v-bind:obj="obj"      v-if="obj_type == 'RippleState'" />
      <OfferObj       v-bind:obj="obj" v-else-if="obj_type == 'Offer'"       />
      <PaychanObj     v-bind:obj="obj" v-else-if="obj_type == 'PayChannel'"  />
      <EscrowObj      v-bind:obj="obj" v-else-if="obj_type == 'Escrow'"      />
      <SignerListObj  v-bind:obj="obj" v-else-if="obj_type == 'SignerList'"  />
      <!--<CheckObj       v-bind:obj="obj" v-else-if="obj_type == 'Check'"  />-->
    </div>

    <div v-show="!hidden" class="ledger_obj_details">
      <RenderedLedgerObj v-bind:obj="obj" />
    </div>
  </div>
</template>

<script>
import RippleStateObj from './ledger_obj_types/RippleState.vue'
import OfferObj       from './ledger_obj_types/Offer.vue'
import PaychanObj     from './ledger_obj_types/Paychan.vue'
import EscrowObj      from './ledger_obj_types/Escrow.vue'
import SignerListObj  from './ledger_obj_types/SignerList.vue'

import RenderedLedgerObj from './RenderedLedgerObj.vue'

export default {
  name: 'LedgerObjSummary',

  components : {
    RippleStateObj,
    OfferObj,
    PaychanObj,
    EscrowObj,
    SignerListObj,

    RenderedLedgerObj
  },

  props : {
    obj : Object
  },

  data : function(){
    return { hidden : true }
  },

  computed : {
    title : function(){
      return this.obj_type;
    },

    obj_type : function(){
      return this.obj["LedgerEntryType"];
    },
  },

  methods : {
    toggle_details : function(){
      this.hidden = !this.hidden;
    }
  }
}
</script>

<style scoped>
.ledger_obj_summary{
  cursor: pointer;
}
</style>
